import { DateTime } from "luxon";

export const LOCAL_TIMEZONE = DateTime.local().zoneName;
